import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FiltersOffCanvas = ({ open, handleToggle, children }) => {
  return (
    <div className="FiltersOffCanvas">
      <div
        className={classNames('FiltersOffCanvas__overlay', {
          'FiltersOffCanvas__overlay-open': open,
        })}
        onClick={handleToggle}
        aria-hidden="true"
      />
      <div
        className={classNames('FiltersOffCanvas__content', {
          'FiltersOffCanvas__content-open': open,
        })}
        role="dialog"
        aria-modal="true"
        aria-label="Filters"
      >
        {children}
      </div>
    </div>
  );
};

FiltersOffCanvas.propTypes = {
  open: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default FiltersOffCanvas;
